
export enum RunShiftCd {
	FAC = 'FAC',
	OUTBOUND = 'Outbound'}

